(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .component('pendenciasGrid', {
      templateUrl: 'views/pendencias/grid.html',
      bindings: {
        pendencias: '<',
        onUpdate: '&'
      },
      controller: 'PendenciasGridCtrl'
    });
}());
